import React from "react";
import { FiMapPin } from "react-icons/fi";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/footer.scss";

function Footer() {
  return (
    <footer className="site-footer" role="contentinfo">
      <section className="newsletter-strip" aria-label="Customer care">
        <div className="container newsletter-strip__inner">
          <div>
            <p className="eyebrow">Here when you need us</p>
            <h2>Questions about an order?</h2>
            <p>
              Our customer care team usually replies within one business day.
            </p>
          </div>
          <Link className="button button--dark" to="/contact">
            Contact customer care
          </Link>
        </div>
      </section>

      <div className="container footer-grid">
        <div className="footer-brand">
          <Link className="brand brand--footer" to="/">
            <img src={siteConfig.logo} alt={siteConfig.brandName} />
          </Link>
          <p>{siteConfig.description}</p>
        </div>
        <div>
          <h3>Shop</h3>
          <Link to="/shop">All products</Link>
          <Link to="/shop?category=Cheese">Cheese</Link>
          <Link to="/shop?category=Meat%20%26%20Seafood">Charcuterie</Link>
          <Link to="/shop?category=Grocery">Grocery</Link>
          <Link to="/shop?collection=deals">Hot deals</Link>
        </div>
        <div>
          <h3>Discover</h3>
          <Link to="/about">Our story</Link>
          <Link to="/shipping">Delivery guide</Link>
          <Link to="/returns">Returns</Link>
          <Link to="/faqs">FAQs</Link>
          <Link to="/policies">Policy center</Link>
          <Link to="/contact">Contact us</Link>
        </div>
        <div>
          <h3>Customer care</h3>
          <a href={`mailto:${siteConfig.contact.email}`}>
            {siteConfig.contact.email}
          </a>
          <p className="footer-address">
            <FiMapPin /> {siteConfig.contact.address}
          </p>
          <p>{siteConfig.contact.hours}</p>
        </div>
      </div>
      <div className="container footer-bottom">
        <p>© 2026 {siteConfig.brandName}. All rights reserved.</p>
        <div className="payment-methods" aria-label="Supported payment methods">
          <span>Visa</span>
          <span>Mastercard</span>
          <span>American Express</span>
          <span>UnionPay</span>
        </div>
        <div>
          <Link to="/policies">All policies</Link>
          <Link to="/privacy">Privacy</Link>
          <Link to="/cookies">Cookies</Link>
          <Link to="/terms">Terms</Link>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
